import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Sobre from '@/components/Sobre'
import Historia from '@/components/Historia'
import Diferenciais from '@/components/Diferenciais'
import Valores from '@/components/Valores'
import Blog from '@/components/Blog'
import BlogInterna from '@/components/BlogInterna'
import Empresas from '@/components/Empresas'
import Empreendimentos from '@/components/empreendimentos/Empreendimentos'
import Interna from '@/components/empreendimentos/Interna'
import InternaApresentacao from '@/components/empreendimentos/InternaApresentacao'
import InternaPlantas from '@/components/empreendimentos/InternaPlantas'
import InternaGaleria from '@/components/empreendimentos/InternaGaleria'
import InternaTour from '@/components/empreendimentos/InternaTour'
import InternaEstagio from '@/components/empreendimentos/InternaEstagio'
import InternaLocalizacao from '@/components/empreendimentos/InternaLocalizacao'
import Comparar from '@/components/Comparar'
import Contato from '@/components/Contato'
import Campaig from '@/components/Campaig'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/sobre',
      name: 'Sobre',
      component: Sobre
    },
    {
      path: '/historia',
      name: 'Historia',
      component: Historia
    },
    {
      path: '/diferenciais',
      name: 'Diferenciais',
      component: Diferenciais
    },
    {
      path: '/valores',
      name: 'Valores',
      component: Valores
    },
    {
      path: '/empresas',
      name: 'Empresas',
      component: Empresas
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/blog/tag/:slug',
      name: 'BlogTag',
      component: Blog
    },
    {
      path: '/blog/:slug',
      name: 'BlogInterna',
      component: BlogInterna
    },
    {
      path: '/empreendimentos',
      name: 'Empreendimentos',
      component: Empreendimentos
    },
    {
      path: '/empreendimentos/filter/:slug',
      name: 'EmpreendimentosFilter',
      component: Empreendimentos
    },
    {
      path: '/empreendimentos/categories/:slug',
      name: 'EmpreendimentosCategories',
      component: Empreendimentos
    },
    {
      path: '/comparar',
      name: 'Comparar',
      component: Comparar
    },
    {
      path: '/contato',
      name: 'Contato',
      component: Contato
    },
    {
      path: '/contato/:slug',
      name: 'Contato',
      component: Contato
    },
    {
      path: '/campanha/:slug',
      name: 'Campanha',
      component: Campaig
    },
    {
      path: '/empreendimentos/:slug',
      name: 'Interna',
      component: Interna,
      children: [
        {
          path: 'apresentacao',
          name: 'InternaApresentacao',
          component: InternaApresentacao
        },
        {
          path: 'plantas',
          name: 'InternaPlantas',
          component: InternaPlantas
        },
        {
          path: 'galeria',
          name: 'InternaGaleria',
          component: InternaGaleria
        },
        {
          path: 'tour',
          name: 'InternaTour',
          component: InternaTour
        },
        {
          path: 'estagio',
          name: 'InternaEstagio',
          component: InternaEstagio
        },
        {
          path: 'localizacao',
          name: 'InternaLocalizacao',
          component: InternaLocalizacao
        },
        {
          path: 'suaobra',
          beforeEnter (to, from, next) {
            window.location = 'https://comcasa.com.br/cms'
          }
        },
        {
          path: 'corretores',
          beforeEnter (to, from, next) {
            window.location = 'https://comcasa.com.br/cms'
          }
        }
      ]
    },
    {
      path: '/*',
      name: 'Home',
      component: Home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js